import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
 
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from '../../config/index'
const { API_URL } = config

const ChangePassword = ({ history }) => {
    const token = localStorage.getItem('token')

    const [oldPassword, setOldPassword]               = useState('')
    const [newPassword, setNewPassword]               = useState('')
    const [confirmNewPassword, setConfirmNewPassword] = useState('')

    const oldPasswordHandler        = e => setOldPassword(e.target.value)
    const newPasswordHandler        = e => setNewPassword(e.target.value)
    const confirmNewPasswordHandler = e => setConfirmNewPassword(e.target.value)

    const submitHandler = async (e) => {
        e.preventDefault()
        if (newPassword === confirmNewPassword) {
            let url = `${API_URL}/associate/change-password`

            try {
                let data = {
                    old_password: oldPassword,
                    new_password: newPassword,
                }

                let response = await fetch(url, {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    withCredentials: true,
                    mode: 'cors',
                    headers: {
                        "Authorization": token,
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json; charset=utf-8",
                    }
                })

                let json = await response.json()
                
                if (response.ok) {
                    ToastUtil.success('Password successfully updated. Please login again using the updated password.')
                    history.push('/logout')
                } else {
                    ToastUtil.error(json.message)
                }
            } catch (error) {
                console.log(error)
            }
        } else {
            ToastUtil.error('Password don\'t match!')
        }
    }

    return (
        <div className="container">
            <form className="form" onSubmit={e => submitHandler(e)}>
                <div className="d-flex flex-column justify-content-between" style={{minHeight: 'calc(100vh - 57px)'}}>
                    <div className="flex-grow-1 d-flex flex-column mt-4">
                        <input type="password" placeholder="Current Password" className="form-control my-2" value={oldPassword} onChange={e => oldPasswordHandler(e)} />
                        <input type="password" placeholder="New Password" className="form-control my-2" value={newPassword} onChange={e => newPasswordHandler(e)} />
                        <input type="password" placeholder="Confirm New Password" className="form-control my-2" value={confirmNewPassword} onChange={e => confirmNewPasswordHandler(e)} />
                    </div>
                    <button type="submit" className="btn btn-design btn-brand btn-block mb-4">Save Changes</button>
                </div>
            </form>
        </div>
    )
}

export default withRouter(ChangePassword)
